import React, { useEffect, useMemo, useState } from "react";
import PDHeadingSection from "./PDHeadingSection";
import PDPropertyDataSection from "./PYPPropertyDataSection";
import PDAboutProperty from "./PYPAboutProperty";
import PDMapView from "../../propertyDetail/PDMapView";
import PDAvailableServicesCard from "../../propertyDetail/PDAvailableServicesCard";
import PDGallerySection from "../../propertyDetail/PDGallerySection";
import PDContactAuthorizedOfficer from "../../propertyDetail/PDContactAuthorizedOfficer";
import HowToStartBidding from "../../home/howToStartBidding/HowToStartBidding";
import FAQSection from "../../home/faq/FAQSection";
import PDDownloadDocuments from "../../propertyDetail/PDDownloadDocuments";
import ResidentialProperties from "../../home/residentialProperties/ResidentialProperties";
import AcknowledgementCard from "../../../../shadcn/components/custom/AcknowledgementCard";
import { AuthModalWrapper } from "../../Auth/AuthModal";

import { useSelector } from "react-redux";
import CustomModalLayout from "../../Auth/CustomModalLayout";
import PDKnowMoreAboutPropertyCard from "../../propertyDetail/PDKnowMoreAboutPropertyCard";
import { bidInterest } from "services";
import PYPAmentitiesCard from "./PYPPAmentitiesCard";
import { PYPRatingsCard } from "./PYPRatingsCard";

interface PropertyDetailWrapperProps {
  propertyData: any;
  defaultLocation: any;
}

export default function PropertyDetailWrapper({
  propertyData,
  defaultLocation,
}: PropertyDetailWrapperProps) {
  const [authModelOpen, setAuthModelOpen] = useState(false);
  const [acknowledgementOpen, setAcknowledgementOpen] = useState(false);
  const [acknowledgementDetails, setAcknowledgementDetails] = useState({
    name: "",
    mobile: "",
    email: "",
    isFooter: false,
  });
  const isLoggedIn = useSelector((state: any) => state.auth.user);

  const area = propertyData?.posted_properties_raw_data?.builtUpArea
    ? propertyData?.posted_properties_raw_data?.builtUpArea
    : propertyData?.posted_properties_raw_data?.carpetArea;

  const balcony = propertyData?.posted_properties_raw_data?.noOfBalcony?.value
    ? propertyData?.posted_properties_raw_data?.noOfBalcony?.value === "1"
      ? `${propertyData?.posted_properties_raw_data?.noOfBalcony?.value} Balcony`
      : `${propertyData?.posted_properties_raw_data?.noOfBalcony?.value} Balconies`
    : "";

  const bathroom = propertyData?.posted_properties_raw_data?.noOfBathroom?.value
    ? propertyData?.posted_properties_raw_data?.noOfBathroom?.value === "1"
      ? `${propertyData?.posted_properties_raw_data?.noOfBathroom?.value} Bathroom`
      : `${propertyData?.posted_properties_raw_data?.noOfBathroom?.value} Bathrooms`
    : "";

  const parking = propertyData?.posted_properties_raw_data?.noOfParking?.value
    ? propertyData?.posted_properties_raw_data?.noOfParking?.value === "1"
      ? `${propertyData?.posted_properties_raw_data?.noOfParking?.value} Parking`
      : `${propertyData?.posted_properties_raw_data?.noOfParking?.value} Parkings`
    : "";

  const propertyAge =
    propertyData?.posted_properties_raw_data?.ageOfPropertyAdv;
  const totalFloors = propertyData?.posted_properties_raw_data?.totalFloorAdv;

  const result = [bathroom, parking, balcony].filter(Boolean).join(", ");
  propertyData["totalFloors"] = totalFloors;
  propertyData["configuration"] = result;
  propertyData["ageOfProperty"] = propertyAge;

  const propertyImages =
    propertyData.posted_properties_data?.property_photos.map((item: any) => ({
      uuid: item.id,
      path_to_file: `https://auction-bazaar-staging-1.s3.ap-south-1.amazonaws.com/${item.id}`,
    }));
  propertyData.possession_type =
    propertyData?.posted_properties_raw_data?.constructionStatus?.value ===
    "ready_to_move"
      ? "Ready To Move"
      : propertyData?.posted_properties_raw_data?.possessionDate;

  propertyData.area = propertyData?.area ? propertyData?.area : area;

  const handleInterested = async () => {
    const payload: {
      name: string;
      mobile_number?: string;
      email?: string;
      property_id: string;
    } = {
      name: acknowledgementDetails.name,
      property_id: propertyData.listing_id,
    };

    if (acknowledgementDetails?.mobile?.length === 10) {
      payload.mobile_number = acknowledgementDetails.mobile;
    }

    if (
      acknowledgementDetails.email &&
      acknowledgementDetails?.email?.length > 3
    ) {
      payload.email = acknowledgementDetails.email;
    }

    try {
      await bidInterest(payload);
      setAcknowledgementOpen(false);
    } catch (error) {
      console.error("Error handling bid interest:", error);
    }
  };
  const convertToDecimal = (coord: string): number => {
    const dmsRegex = /^(\d{1,3})°(\d{1,2})'(\d{1,2}(\.\d+)?)$/;
    const nsewRegex = /^([0-9]+(\.[0-9]+)?)\s?[nswe]$/i;

    const match = coord.match(dmsRegex);
    if (match) {
      const degrees = parseFloat(match[1]);
      const minutes = parseFloat(match[2]);
      const seconds = parseFloat(match[3]);
      return degrees + minutes / 60 + seconds / 3600;
    }
    const matchNSEW = coord.match(nsewRegex);
    if (matchNSEW) {
      const decimalCoord = parseFloat(matchNSEW[1]);
      const direction = matchNSEW[0].toLowerCase().slice(-1);
      if (direction === "s" || direction === "w") {
        return -decimalCoord;
      }
      return decimalCoord;
    }

    return parseFloat(coord);
  };

  const locationCoordinates = propertyData?.location_coordinates;
  let coordinates = {
    isCoordinatesFound: false,
    value: ["na", "na"],
  };
  if (
    locationCoordinates &&
    !locationCoordinates?.toLowerCase()?.includes("na") &&
    !locationCoordinates?.toLowerCase()?.includes("no") &&
    !locationCoordinates?.toLowerCase()?.includes("contact no") &&
    !locationCoordinates?.toLowerCase()?.includes("null")
  ) {
    if (locationCoordinates.includes(",")) {
      const foundCoordinates = locationCoordinates
        .split(",")
        .map((coord: string) =>
          coord
            .toString()
            .replace(/[^\d.-]/g, "")
            .trim()
        )
        .map((coord: string) => {
          return convertToDecimal(coord.replace(/[nesw]/gi, "").trim());
        });

      if (isNaN(foundCoordinates[0]) || isNaN(foundCoordinates[1])) {
        coordinates = {
          isCoordinatesFound: false,
          value: foundCoordinates,
        };
      }

      coordinates = {
        isCoordinatesFound: true,
        value: foundCoordinates,
      };
    } else if (locationCoordinates && locationCoordinates.includes(" ")) {
      // Handle space-separated coordinates (e.g., 30.89 75.89)
      const foundCoordinates = locationCoordinates
        .split(" ")
        .map((coord: string) =>
          convertToDecimal(
            coord
              .toString()
              .replace(/[^\d.-]/g, "")
              .trim()
          )
        );
      if (isNaN(foundCoordinates[0]) || isNaN(foundCoordinates[1])) {
        coordinates = {
          isCoordinatesFound: false,
          value: foundCoordinates,
        };
      }

      coordinates = {
        isCoordinatesFound: true,
        value: foundCoordinates,
      };
    }
  }

  return (
    <div className="bg-white">
      <div className="lg:hidden">
        <div className="px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <PDHeadingSection
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
            titleName={"Seller"}
            propertyImages={propertyImages}
          />
          <PDPropertyDataSection propertyData={propertyData} />
          <PDAboutProperty />
          {propertyData?.sub_asset_type?.slug !== "flat" &&
          propertyData?.posted_properties_raw_data?.societyAmentities ? (
            <PYPAmentitiesCard
              title="Project Amentities"
              bgColor="bg-[#F9F7FF]"
              projectData={
                propertyData?.posted_properties_raw_data?.societyAmentities
              }
            />
          ) : (
            <></>
          )}

          {propertyData?.posted_properties_raw_data?.flatFurnishing &&
          (propertyData?.sub_asset_type?.slug === "individual-house" ||
            propertyData?.sub_asset_type?.slug === "flat") ? (
            <PYPAmentitiesCard
              title="Furnishings Details"
              bgColor="bg-[#FFF8F5]"
              projectData={
                propertyData?.posted_properties_raw_data?.flatFurnishing
              }
            />
          ) : (
            <></>
          )}

          {/* Floor Plan */}
          <></>

          <PDMapView
            isCoordinateFound={coordinates.isCoordinatesFound}
            position={coordinates.value}
            locality={{
              isFound: propertyData?.locality?.name ? true : false,
              value: propertyData?.locality?.name
                ? propertyData?.locality?.name
                : null,
            }}
            city={propertyData?.city}
            state={propertyData?.state}
          />
          <PDKnowMoreAboutPropertyCard
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          <PDAvailableServicesCard />
        </div>
        <PDGallerySection images={propertyImages} />
        <div className="px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <PDContactAuthorizedOfficer
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
            propertyType="private_property"
          />
          <PDDownloadDocuments
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          {/* <ResidentialProperties defaultLocation={defaultLocation} /> */}
          <HowToStartBidding />
          <FAQSection />
        </div>
      </div>
      <div className="hidden lg:block px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <PDHeadingSection
          propertyData={propertyData}
          setAuthModelOpen={setAuthModelOpen}
          setAcknowledgementOpen={setAcknowledgementOpen}
          setAcknowledgementDetails={setAcknowledgementDetails}
          titleName="Seller"
          propertyImages={propertyImages}
        />
        <PDPropertyDataSection propertyData={propertyData} />
        <div className="grid lg:grid-cols-[minmax(0,1fr)_348px] lg:gap-x-8">
          <div className="order-1 " id="px-12235">
            {propertyData?.sub_asset_type?.slug === "flat" &&
            propertyData?.posted_properties_raw_data?.societyAmentities ? (
              <PYPAmentitiesCard
                title="Project Amentities"
                bgColor="bg-[#F9F7FF]"
                projectData={
                  propertyData?.posted_properties_raw_data?.societyAmentities
                }
              />
            ) : (
              <></>
            )}
          </div>
          <div className="order-3">
            {propertyData?.posted_properties_raw_data?.flatFurnishing &&
            (propertyData?.sub_asset_type?.slug === "individual-house" ||
              propertyData?.sub_asset_type?.slug === "flat") ? (
              <PYPAmentitiesCard
                title="Furnishings Details"
                bgColor="bg-[#FFF8F5]"
                projectData={
                  propertyData?.posted_properties_raw_data?.flatFurnishing
                }
              />
            ) : (
              <></>
            )}
          </div>
          <div className="order-9">
            {propertyData?.sub_asset_type?.slug === "individual-house" ||
            propertyData?.sub_asset_type?.slug === "flat" ? (
              <PYPRatingsCard />
            ) : (
              <></>
            )}
          </div>
          <div className="order-8">
            <PDAboutProperty />
          </div>
          <div className="order-4">
            <PDMapView
              isCoordinateFound={coordinates.isCoordinatesFound}
              position={coordinates.value}
              locality={{
                isFound: propertyData?.locality?.name ? true : false,
                value: propertyData?.locality?.name
                  ? propertyData?.locality?.name
                  : null,
              }}
              city={propertyData?.city}
              state={propertyData?.state}
            />
          </div>
          <div className="order-6">
            <PDAvailableServicesCard />
          </div>{" "}
          <div className="order-7">
            <PDKnowMoreAboutPropertyCard
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
            />
          </div>
          <div className="order-5">
            <PDGallerySection images={propertyImages} />
          </div>
          <div className="order-2 row-span-10">
            <PDContactAuthorizedOfficer
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
              propertyType="private_property"
            />
            <PDDownloadDocuments
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
            />
          </div>
        </div>
        {/* <ResidentialProperties defaultLocation={defaultLocation} /> */}
        <FAQSection />
      </div>
      <AuthModalWrapper
        userLoggedin={isLoggedIn}
        authModelOpen={authModelOpen}
        setAuthModelOpen={setAuthModelOpen}
      />
      <CustomModalLayout
        open={acknowledgementOpen}
        onClose={() => setAcknowledgementOpen(false)}
        childrenClassName="pl-4 pr-6"
        className="pt-8 pb-[30px]"
      >
        <AcknowledgementCard
          name={acknowledgementDetails.name ? acknowledgementDetails.name : ""}
          message="Thank you for your interest in the property. Our team will connect with you soon to provide further details."
          hideBottomActions={
            acknowledgementDetails?.isFooter
              ? !acknowledgementDetails.isFooter
              : true || true
          }
          contactInfo={{
            mobileNumber: `+91 ${acknowledgementDetails?.mobile || ""}`,
            email: acknowledgementDetails?.email || "",
          }}
          handleInterested={handleInterested}
          handleNotInterested={() => setAcknowledgementOpen(false)}
        />
      </CustomModalLayout>
    </div>
  );
}
